export interface RelodeConstants {
    DEFAULT_SEARCH_RADIUS_METERS: number;
    REMOTE_LOCATION_ID: number;
    ANY_LOCATION_ID: number;
    EMAIL_VALIDATION_REGEX: RegExp;
    INDEED_EMAIL_VALIDATION_REGEX: RegExp;
    PHONE_NUMBER_REGEX: RegExp;
    QUALIFICATION_PLACEHOLDER_ID_START: number;
}

export const initializeRelodeConstants = () => {
    if (window.relodeConstants) return;

    window.relodeConstants = {
        DEFAULT_SEARCH_RADIUS_METERS: 50 * 1610,
        REMOTE_LOCATION_ID: 5,
        ANY_LOCATION_ID: 1,
        // eslint-disable-next-line max-len
        EMAIL_VALIDATION_REGEX: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$|^$/,
        INDEED_EMAIL_VALIDATION_REGEX: /^.*[Ii][Nn][Dd][Ee][Ee][Dd][Ee][Mm][Aa][Ii][Ll].[Cc][Oo][Mm]/,

        /*
         * This regex matches the following patterns:
         * 6155551234
         * 16155551234
         * +16155551234
         * (615) 555-1234
         * 1 (615) 555-1234
         * +1 615 555 1234
         * +1 615 555-1234
         * or an empty string
         */
        PHONE_NUMBER_REGEX: /^\+?[1]? ?\(?\d{3}\)? \d{3}[-| ]\d{4}$|^[2-9]{1}\d{9}|^\+?[1]\d{10}$|^$/,

        // this number is 7,199,254,730,991 less than the javascript Number.MAX_SAFE_INTEGER of 9,007,199,254,730,991
        // this should not run out while a user has the browser open.  Restarting app will cause the number to reset.
        QUALIFICATION_PLACEHOLDER_ID_START: 9000000000000000,
    };
};
